import { useState } from "react";
import { AlertCircle, Target, Radio, AlertTriangle, Shield } from "lucide-react";
import { FaSync } from "react-icons/fa";
// Import the StatsCard instead of EventSummaryCards
// import StatsCard from "../../components/modules/overview/StatsCard/StatsCard"; 
import { ThreatTimelineChart } from "../../components/modules/AuthEvents/ThreatTimeLineChart";
import { useAuthEvents } from "../../hooks/useAuthEvents";
import "./AuthEventsPage.css";

const AuthEventsPage = () => {
    // const { kpiSummary, loading, error, timelineMode, refresh, timeline, timelineLoading } = useAuthEvents();
    const {error, timelineMode, refresh, timeline, timelineLoading } = useAuthEvents();
    const [timeFilter, setTimeFilter] = useState("today");

    // ... (keep filterTimelineData logic the same)
    const filterTimelineData = (data, filter) => {
        if (!data) return [];
        const now = new Date();
        return (Array.isArray(data)? data : []).filter((item) => {
            const date = new Date(item?.time ?? new Date());
            switch (filter) {
                case "7d": return now - date <= 7 * 24 * 60 * 60 * 1000;
                case "24h": return now - date <= 24 * 60 * 60 * 1000;
                case "today":
                    return (
                        date.getDate() === now.getDate() &&
                        date.getMonth() === now.getMonth() &&
                        date.getFullYear() === now.getFullYear()
                    );
                default: return true;
            }
        });
    };

    const filteredTimeline = filterTimelineData(timeline, timeFilter) ?? [];
    const mappedTimeline = filteredTimeline.map((item) => {
        const date = new Date(item?.time ?? new Date());
        let formattedTime;
        if (timeFilter === "today" || timeFilter === "24h") {
            formattedTime = date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" });
        } else {
            formattedTime = date.toLocaleDateString([], { weekday: "short", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", second: "2-digit" });
        }
        return {
            time: formattedTime ?? new Date(),
            threat: item?.threat ?? 0,
            total: item?.total ?? 0,
        };
    });

    return (
        <div className="events-auth-activity-page">
            {/* Header */}
            {/* <div className="auth-activity-page__header">
                <div>
                    <h1 className="auth-activity-page__title">Authentication Events: Threat Timeline</h1>
                    <p className="auth-activity-page__subtitle">Real-time ITDR events and threat score monitoring</p>
                </div>
            </div> */}

            {/* Error */}
            {error && (
                <div className="auth-activity-page__error">
                    <div className="auth-activity-page__error-content">
                        <AlertCircle size={16} />
                        <span>{error}</span>
                    </div>
                    <button className="auth-activity-page__error-retry" onClick={refresh}>
                        <FaSync size={12} /> Retry
                    </button>
                </div>
            )}

            <ThreatTimelineChart 
                mode={timelineMode} 
                data={mappedTimeline} 
                loading={timelineLoading} 
                timeFilter={timeFilter} 
                setTimeFilter={setTimeFilter} 
            />
        </div>
    );
};

export { AuthEventsPage };